var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 31,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 54.4727V45.8C10.75 38.8412 16.7942 33.2 24.25 33.2H37.75C45.2058 33.2 51.25 38.8412 51.25 45.8V54.4727C45.8178 59.1633 38.7402 62 31 62C23.2598 62 16.1822 59.1633 10.75 54.4727Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 19C43.5 25.4617 37.9233 31.4 31 31.4C24.0767 31.4 18.5 25.4617 18.5 19C18.5 12.5383 24.0767 7 31 7C37.9233 7 43.5 12.5383 43.5 19Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUser);
export default __webpack_public_path__ + "static/media/default_user.0dbb1760bc023183251b6863c65f5b56.svg";
export { ForwardRef as ReactComponent };